import axios from "axios";
import {
	NULL_FILE_ERROR,
	UPLOADING_ATTACHMENT_ERROR,
	UPLOAD_ATTACHMENT_ERROR_ID,
	UPLOADING_FILING_ERROR,
	UPLOADING_FILING_ERROR_ID
} from "../constants/errors";
import { SIGNED_URL_ENDPOINT, UPLOAD_METADATA_ENDPOINT } from "../constants/api";
import {
	FORMAL_FILING_FORM_TYPE,
	OTHER_FILING_FORM_TYPE,
	RECORDATION_FORM_TYPE,
	RECORDATION_DATE_OF_AGREEMENT_FIELD,
	IS_PUBLIC_FIELD,
	PRIMARY_RECORDATION_NUM_FIELD,
	SUBMITTER_FIELD,
	ADDRESS_ONE_FIELD,
	ADDRESS_TWO_FIELD,
	CITY_FIELD,
	STATE_FIELD,
	ZIP_FIELD,
	COUNTRY_FIELD,
	PHONE_FIELD,
	EMAIL_FIELD,
	RECORDATION_TYPE_OF_AGREEMENT_FIELD,
	HAC_FIELD,
	EQUIPMENT_DESCRIPTION_FIELD,
	PARTY_TYPE_FIELD,
	OTHER_PARTY_TYPE_FIELD,
	CONFIRMATION_NUM_FIELD,
	COMPANY_FIELD,
	RCPA_FORM_TYPE,
	ISSUE_FIELD,
	COMMODITY_GROUP_FIELD,
	REGION_FIELD,
	RAILROADS_INVOLVED_FIELD,
	PROBLEM_LOCATION_FIELD,
	INDUSTRY_LOCATION_FIELD,
	PROBLEM_DATES_FIELD,
	ISSUE_SUMMARY_FIELD,
	CONTACT_PERMISSION_FIELD,
	JOB_TITLE_FIELD,
	FAX_FIELD,
	ENVIRONMENTAL_COMMENTS_FORM_TYPE,
	ENVCOM_PROJECT_FIELD,
	ENVCOM_ATTENTION_FIELD,
	ENVCOM_YOUR_NAME_FIELD,
	ENVCOM_ORGANIZATION_FIELD,
	ENVCOM_AFFILIATION_FIELD,
	ENVCOM_COMMENTS_FIELD,
	RECORDATION_WATER_RAIL_FIELD
} from "../constants/fields";
import { COUNTRIES } from "../constants/dropdowns";
import { getMDYfromYMDFormat } from "./dateUtil";

export const sendDataAsync = async (state, dispatch, e) => {
	var efilingState = {...state};
	let networkErrors = [];
	let abortRedirect = false;
	for (let i = 0; i < state.data.attachments.length; i++) {
		if (state.data.attachments[i].state.file !== null) {
			await uploadFileToS3(
				state.data.attachments[i].state.file,
				(signedUrl) => {
					efilingState.data.attachmentStrings.push(signedUrl);
				}
			).then(success => {
				if (!success) {
					networkErrors.push({
						errorMsg: UPLOADING_ATTACHMENT_ERROR,
						fieldId: `${UPLOAD_ATTACHMENT_ERROR_ID}-${i}`
					});
					dispatch({type: "setState", newState: { data: {...efilingState.data, attachmentStrings: [] } } });
				}
			});
		}
	}

	await sendEfilingToAppian(efilingState.form.type, efilingState.data).then(success => {
		if (!success) {
			networkErrors.push({
				errorMsg: UPLOADING_FILING_ERROR,
				fieldId: UPLOADING_FILING_ERROR_ID
			});
			abortRedirect = true;
		}
		return true;
	});
	if (networkErrors.length) {
		dispatch({type: "setState", newState: { form: {...efilingState.form, networkErrors: networkErrors, loading: false } } });
	}
	if (abortRedirect) {
		return false;
	} else {
		e.preventDefault();
		dispatch({type: "setState", newState: { form: {...efilingState.form, success: true, loading: false } } });
		return true;
	}
};

export async function uploadFileToS3(file, addAttachmentUrl) {
	if (file === null || file === undefined || file === "") {
		console.log(NULL_FILE_ERROR);
		return false;
	}
	const uniqueFileName = `${Date.now()}/${file.name}`;
	
	await axios
		.get(SIGNED_URL_ENDPOINT, {
			params: {
				filename: uniqueFileName,
				filetype: file.type
			}
		})
		.then(async result => {
			var signedUrl = result.data.signedUrl;
			const config = {
				headers: {
					"Content-Type": file.type
				}
			};
			try {
				const result_1 = await axios.put(signedUrl, file, config);
				addAttachmentUrl(signedUrl);
				return result_1;
			} catch (err) {
				console.log(err);
				return false;
			}
		})
		.catch(err => {
			console.log(err);
			return false;
		});
	return true;
}

function getUploadPathFromUrl(url) {
	var isValidUrl = url.includes("?");
	if (isValidUrl) {
		let urlPaths = url.split("?").shift().split("/");
        if (urlPaths.length < 2) {
            return url;
        }
		let timestamp = urlPaths[urlPaths.length - 2];
		let filename = urlPaths[urlPaths.length - 1];
		let uploadPath = `${timestamp}/${filename}`;
        return uploadPath;
	} else {
		return url;
	}
}

export async function sendEfilingToAppian(type, data) {
	var success = false;
	const date = new Date();
	var efilingData = {};
	switch(type) {
		case FORMAL_FILING_FORM_TYPE:
		case OTHER_FILING_FORM_TYPE:
			efilingData = {
				filing: {
					isEFiling: true,
					filingDt: `${date.getMonth() +
						1}/${date.getDate()}/${date.getFullYear()}`
				},
				parties: data.parties.map(party => ({
					filedFor: party.state.filedFor,
					filedBy: party.state.filedBy,
					company: party.state.company,
					address1: party.state.address1,
					address2: party.state.address2,
					city: party.state.city,
					state: party.state.state,
					zip: party.state.zip,
					phone: stripPhoneNumber(party.state.phone),
					fax: stripPhoneNumber(party.state.fax),
					email: party.state.email,
					country:
						party.state.country === null ||
						party.state.country === ""
							? COUNTRIES[0]
							: party.state.country
				})),
				additionalPartyEmails: data.parties.map(party => ({
					email: [...party.state.additionalEmails]
				})),
				attachmentStrings: data.attachmentStrings.reduce(
					(acc, cur) => [...acc, getUploadPathFromUrl(cur)],
					[]
				),
				isPublic: data.isPublic,
				docketNumbers: data.docketNumbers.map(docketNumber => ({
					docketPrefix: docketNumber.docketPrefix,
					railroadCode: docketNumber.docketPrefix === "AB" ? docketNumber.sequenceNumber : null,
					seqNo: docketNumber.docketPrefix === "AB" ? null : docketNumber.sequenceNumber,
					subSeqNo: docketNumber.subSequenceNumber,
					docketSuffix: docketNumber.docketSuffix
				})),
				confirmationNumber: data.confirmationNumber || null,
				isOtherFiling: data.isOtherFiling,
				generalFilingType: data.generalFilingType || null,
				feeStatus: data.feeOption || null
			}
			break;
		case RECORDATION_FORM_TYPE:
			efilingData = {
				attachmentStrings: data.attachmentStrings.reduce(
					(acc, cur) => [...acc, getUploadPathFromUrl(cur)],
					[]
				),
				isPublic: data[IS_PUBLIC_FIELD],
				eRecordation: {
					waterOrRailRecordation: data[RECORDATION_WATER_RAIL_FIELD],
					primaryRecordation: data[PRIMARY_RECORDATION_NUM_FIELD] || null,
					confirmationNumber: data[CONFIRMATION_NUM_FIELD],
					submitter: data[SUBMITTER_FIELD],
					company: data[COMPANY_FIELD],
					address1: data[ADDRESS_ONE_FIELD],
					address2: data[ADDRESS_TWO_FIELD],
					city: data[CITY_FIELD],
					state: data[STATE_FIELD],
					zip: data[ZIP_FIELD],
					country: data[COUNTRY_FIELD],
					phone: stripPhoneNumber(data[PHONE_FIELD]),
					email: data[EMAIL_FIELD],
					dateOfAgreement: getMDYfromYMDFormat(data[RECORDATION_DATE_OF_AGREEMENT_FIELD]),
					typeOfAgreement: data[RECORDATION_TYPE_OF_AGREEMENT_FIELD],
					hasIdentifiedHac: data[HAC_FIELD],
					equipmentDescription: data[EQUIPMENT_DESCRIPTION_FIELD],
				},
				eRecordationParties: data.parties.map(party => ({
					partyType: party.state[PARTY_TYPE_FIELD],
					otherPartyType: party.state[OTHER_PARTY_TYPE_FIELD],
					company: party.state[COMPANY_FIELD],
					address1: party.state[ADDRESS_ONE_FIELD],
					address2: party.state[ADDRESS_TWO_FIELD],
					city: party.state[CITY_FIELD],
					state: party.state[STATE_FIELD],
					zip: party.state[ZIP_FIELD],
					country:
						party.state[COUNTRY_FIELD] === null ||
						party.state[COUNTRY_FIELD] === ""
							? COUNTRIES[0]
							: party.state[COUNTRY_FIELD]
				})),
			}
			break;
		case RCPA_FORM_TYPE:
			efilingData = {
				attachmentStrings: data.attachmentStrings.reduce(
					(acc, cur) => [...acc, getUploadPathFromUrl(cur)],
					[]
				),
				eRcpaRequest: {
					submitter : data[SUBMITTER_FIELD],
					company : data[COMPANY_FIELD],
					jobTitle : data[JOB_TITLE_FIELD],
					address1 : data[ADDRESS_ONE_FIELD],
					address2 : data[ADDRESS_TWO_FIELD],
					city : data[CITY_FIELD],
					state : data[STATE_FIELD],
					zip : data[ZIP_FIELD],
					country : data[COUNTRY_FIELD],
					email : data[EMAIL_FIELD],
					phone : stripPhoneNumber(data[PHONE_FIELD]),
					fax : stripPhoneNumber(data[FAX_FIELD]),
					issue : data[ISSUE_FIELD],
					commodityGroup : data[COMMODITY_GROUP_FIELD],
					region : data[REGION_FIELD],
					railroadsInvolved : data[RAILROADS_INVOLVED_FIELD],
					problemLocation : data[PROBLEM_LOCATION_FIELD],
					industryLocation : data[INDUSTRY_LOCATION_FIELD],
					problemDates : data[PROBLEM_DATES_FIELD],
					issueSummary : data[ISSUE_SUMMARY_FIELD],
					canContact : data[CONTACT_PERMISSION_FIELD]
				}
			}
			break;
		case ENVIRONMENTAL_COMMENTS_FORM_TYPE:
			efilingData = {
				attachmentStrings: data.attachmentStrings.reduce(
					(acc, cur) => [...acc, getUploadPathFromUrl(cur)],
					[]
				),
				dockets: data.docketNumbers.map(docketNumber => ({
					docketPrefix: docketNumber.docketPrefix,
					railroadCode: docketNumber.docketPrefix === "AB" ? docketNumber.sequenceNumber : null,
					seqNo: docketNumber.docketPrefix === "AB" ? null : docketNumber.sequenceNumber,
					subSeqNo: docketNumber.subSequenceNumber,
					docketSuffix: docketNumber.docketSuffix
				})),
				eEnviroComment: {
					projectName: data[ENVCOM_PROJECT_FIELD],
					attentionOf: data[ENVCOM_ATTENTION_FIELD],
					submitter: data[ENVCOM_YOUR_NAME_FIELD],
					organization: data[ENVCOM_ORGANIZATION_FIELD],
					affiliation: data[ENVCOM_AFFILIATION_FIELD],
					address1: data[ADDRESS_ONE_FIELD],
					address2: data[ADDRESS_TWO_FIELD],
					city: data[CITY_FIELD],
					state: data[STATE_FIELD],
					zip: data[ZIP_FIELD],
					country: data[COUNTRY_FIELD],
					phone: data[PHONE_FIELD],
					email: data[EMAIL_FIELD],
					receivedDt: `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`,
					comments: data[ENVCOM_COMMENTS_FIELD]
				}
			}
			break;
		default:
			console.log("Efiling error");
			return false;
	}
	
	await axios
		.put(UPLOAD_METADATA_ENDPOINT, {
			type: type,
			data: efilingData
		})
		.then(result => {
			if (result.status === 200) {
				console.log("Submission Successful!");
			}
			success = true;
		})
		.catch(err => {
			console.log("Efiling error: ");
			console.log(err);
			success = false;
		});
		
		console.log("Submission Successful!");
	return success;
}

const stripPhoneNumber = phone => phone.replace(/[^0-9]/g, "");
